/* ============================================================
   Formatter angka & tanggal bersama.
   Sebelumnya tiap layar menulis sendiri
   `toLocaleString(lang==="id" ? "id-ID" : "en-US")`; chart butuh
   format yang konsisten di sumbu, tooltip, dan tabel, jadi
   dikumpulkan di sini.
   ============================================================ */

export function locale(lang) {
  return lang === 'id' ? 'id-ID' : 'en-US'
}

// Angka biasa. `opts` diteruskan apa adanya ke Intl.NumberFormat.
export function fmtNum(n, lang, opts) {
  if (n == null || Number.isNaN(n)) return '—'
  return Number(n).toLocaleString(locale(lang), opts)
}

export function fmtPct(n, lang, digits = 0) {
  if (n == null || Number.isNaN(n)) return '—'
  return `${Number(n).toLocaleString(locale(lang), {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}%`
}

// Untuk tick sumbu: 12.400 → 12,4 rb / 12.4K.
export function fmtCompact(n, lang) {
  if (n == null || Number.isNaN(n)) return '—'
  const v = Number(n)
  if (Math.abs(v) < 1000) return v.toLocaleString(locale(lang))
  return v.toLocaleString(locale(lang), { notation: 'compact', maximumFractionDigits: 1 })
}

// String date-only ("2026-09-02") → "02 Sep".
// `T00:00:00Z` + timeZone UTC wajib dipertahankan: tanpa itu tanggal
// tampil mundur sehari di UTC+7.
export function fmtDateShort(iso, lang) {
  if (!iso) return ''
  const d = new Date(`${iso}T00:00:00Z`)
  if (Number.isNaN(d.getTime())) return String(iso)
  return d.toLocaleDateString(locale(lang), { day: '2-digit', month: 'short', timeZone: 'UTC' })
}

// Sama, tapi dengan tahun — dipakai tooltip agar rentang panjang tidak ambigu.
export function fmtDateLong(iso, lang) {
  if (!iso) return ''
  const d = new Date(`${iso}T00:00:00Z`)
  if (Number.isNaN(d.getTime())) return String(iso)
  return d.toLocaleDateString(locale(lang), {
    day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC',
  })
}

export function fmtHours(h, lang) {
  if (h == null || Number.isNaN(h)) return '—'
  return `${fmtNum(h, lang)} ${lang === 'id' ? 'jam' : 'h'}`
}

// "3 peserta" / "1 participant" / "3 participants".
//
// Hanya sisi Inggris yang bercabang: bahasa Indonesia tidak mengenal bentuk
// jamak, jadi "1 peserta" dan "3 peserta" sama-sama benar dan satu kata sudah
// cukup. Menuntut pasangan tunggal/jamak untuk kedua bahasa hanya mengundang
// "1 pesertas" dari pemanggil yang menurut saja.
//
// Angkanya lewat fmtNum supaya pemisah ribuan ikut bahasa yang aktif:
// "1.200 peserta" di Indonesia, "1,200 participants" di Inggris.
export function fmtCount(n, lang, id, en, enJamak = `${en}s`) {
  const jumlah = fmtNum(n, lang)
  return lang === 'id' ? `${jumlah} ${id}` : `${jumlah} ${n === 1 ? en : enJamak}`
}
